import { useAtom } from 'jotai';
import { parcelSelectionAtom } from '../store/atoms/parcelSelectionAtom';
import type { PaymentPlan } from '../types/payment';
import { useParcelActions } from './useParcelActions';

export function useParcelList(_planId: number) {
  const plan = undefined as PaymentPlan | undefined;

  const [selectedIds, setSelectedIds] = useAtom(parcelSelectionAtom);

  const parcelActions = useParcelActions();

  const toggleSelection = (id: number) => {
    setSelectedIds((prev: Set<number>) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const selectAll = () => {
    if (!plan) return;
    setSelectedIds(new Set(plan.parcels.map(p => p.id)));
  };

  const clearSelection = () => setSelectedIds(new Set());

  const payParcel = (id: number) => {
    const parcel = plan?.parcels.find(p => p.id === id);
    if (!parcel?.courseFinPersonPaymentId) return;

    if (plan?.paymentMethod === 'boleto') {
      parcelActions.generateBillet(parcel.courseFinPersonPaymentId);
    } else if (plan?.paymentMethod === 'credit_card') {
      parcelActions.payCreditCard(parcel.courseFinPersonPaymentId);
    }
  };

  const cancelParcel = (id: number) => {
    const parcel = plan?.parcels.find(p => p.id === id);
    if (!parcel?.courseFinPersonPaymentId) return;

    if (plan?.paymentMethod === 'boleto') {
      parcelActions.cancelBillet(parcel.courseFinPersonPaymentId);
    } else if (plan?.paymentMethod === 'credit_card') {
      parcelActions.refundCreditCard(parcel.courseFinPersonPaymentId);
    }
  };

  const editParcel = (_id: number) => {};
  const renegotiateSelected = () => {};
  const cancelSelected = () => {};
  const openSelected = () => {};

  return {
    plan,
    parcels: plan?.parcels ?? [],
    isLoading: false,
    selectedIds,
    toggleSelection,
    selectAll,
    clearSelection,
    payParcel,
    cancelParcel,
    editParcel,
    renegotiateSelected,
    cancelSelected,
    openSelected,
    // PecegePay state
    generatedBillet: parcelActions.generatedBillet,
    clearGeneratedBillet: parcelActions.clearGeneratedBillet,
    isGeneratingBillet: parcelActions.isGeneratingBillet,
    isCancellingBillet: parcelActions.isCancellingBillet,
  } as const;
}
